import React from "react";

import { Link } from "react-router-dom";

const Post = ({ post }) => {
  return (
    <div className="post">
      <Link to={`/post/${post.id}`} className="imageLink">
        <img src={post.image} alt="..." />
      </Link>
      <h3 className="post_header">
        {post.description.substring(0, 55) + "..."}
      </h3>
      <ul className="tags">
        {post.tags.map((tag, i) => (
          <li className="tag" key={i}>
            {tag}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Post;
